import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { SupplierEmployeeDto } from '@api/models/suppliers/SupplierEmployeeDto';
import { UserState } from '@api/models/enums/UserState';
import { UserRole } from '@api/models/enums/UserRole';
import { supplierEmployeeService } from '@api/services/services';

type State = BaseType<SupplierEmployeeDto>;

const initialState: State = {
  state: FetchState.None,
  data: {
    id: '',
    name: '',
    lastName: '',
    jobPosition: '',
    phone: '',
    email: '',
    language: '',
    note: '',
    carAccessAllowed: true,
    role: UserRole.ExternalManager,
    state: UserState.Active,
  },
};

export const supplierEmployeeSlice = baseSlice({
  name: 'supplierEmployee',
  initialState,
});

export const selectSupplierEmployeeState = (state: RootState) => state.supplierEmployee.state;
export const selectSupplierEmployee = (state: RootState) => state.supplierEmployee.data;
export const supplierEmployeeActions = supplierEmployeeSlice.actions;

export const getSupplierEmployee = (supplierEmployeeId: string) => (dispatch: AppDispatch) => {
  const handleGetData = () => {
    return supplierEmployeeService.getById(supplierEmployeeId);
  };

  getItem({
    dispatch,
    actions: supplierEmployeeActions,
    getData: handleGetData,
  });
};
